// Handle unit price
const unitPrices = document.querySelectorAll('small.unit-price.caption')
for (let i = 0; i < unitPrices.length; ++i)
{
  const unitPrice = unitPrices[i];
  
  if (!unitPrice.classList.contains('hidden'))
  {
    unitPrice.style.fontSize = '16px'
    unitPrice.style.color = 'black';

    unitPrice.parentElement.querySelector('.price__regular').style.display = 'none'
  }

  const unit = unitPrice.querySelector('span.unit')
  if (unit.innerHTML === 'l')
    unit.innerHTML = 'Stück'
  else if (unit.innerHTML === 'm')
    unit.innerHTML = "Meter"
}

// Handle financing rates
const productCards = document.querySelectorAll('.product-card-wrapper');
for (let i = 0; i < productCards.length; ++i)
{
  const productCard = productCards[i];
  const productTitleLink = productCard.querySelector('a.full-unstyled-link');
  if (productTitleLink)
  {
    const productURL = productTitleLink.href.split("?")[0]
    const options = {
        style: "currency",
        currency: "EUR"
    };
    
    fetch(productURL + '.js')
      .then(response => response.json())
      .then(product => {
        if (product.type === "Müllpresse" || product.type === "Abfallverdichter")
        {
          productCard.querySelector('.net-financing-rate-wrapper').style.display = 'block'
          
          const netFinancingRate = Math.round(product.price) / 73.7857 / 100
          const formattedNetFinancingRate = netFinancingRate.toLocaleString('de-DE', options)

          const netFinancingRateSpan = productCard.querySelector('span.net-financing-rate')
          netFinancingRateSpan.innerHTML = formattedNetFinancingRate
        }
      })
  }
}